import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { GymExistenceGQL, GymType } from '@graphql/generated/graphql';
import { map } from 'rxjs';

export const specialInterestGuard: CanActivateFn = () => {
  const router = inject(Router);
  const gymExistenceGQL = inject(GymExistenceGQL);

  return gymExistenceGQL
    .fetch({ where: { type: { equals: GymType.SpecialInterestStudio } } })
    .pipe(
      map(result => {
        const hasSpecialInterest = (result.data.gyms?.length ?? 0) > 0;
        if (!hasSpecialInterest) {
          return router.createUrlTree(['/dashboard']);
        }
        return true;
      })
    );
};
